exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item {\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n}\n.notify-badge {\n  position: absolute;\n  right: -20%;\n  top: -1%;\n  background: red;\n  text-align: center;\n  border-radius: 50%;\n  color: white;\n  padding: 0px 6px;\n  border: 1px solid;\n  font-size: 12px;\n}\n", ""]);

// exports
